import * as React from 'react';
import { observer } from 'mobx-react-lite';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { ChoiceGroup } from '@fluentui/react/lib/ChoiceGroup';
import getRecurrenceChoiceOptions from '../utils/getRecurrenceChoiceOptions';
import { OwaDate } from 'owa-datetime';

export interface RecurrenceChoiceComponentProps {
    start: OwaDate;
    timeZoneId: string;
    recurrence: RecurrenceType;
    onSelectionChangedCallback: (recurrence: RecurrenceType) => void;
    className?: string;
}

const RecurrenceChoiceComponent: React.FunctionComponent<RecurrenceChoiceComponentProps> = props => {
    const { start, timeZoneId, recurrence, onSelectionChangedCallback, className } = props;

    const { options, selectedKey } = getRecurrenceChoiceOptions(start, timeZoneId, recurrence);

    const onChange = React.useCallback(
        (ev: React.FormEvent<HTMLInputElement>, option: any) => {
            for (const item of options) {
                if (item.key == option.key) {
                    onSelectionChangedCallback(item.recurrence);
                }
            }
        },
        [options, onSelectionChangedCallback]
    );

    return (
        <div className={className}>
            <ChoiceGroup
                selectedKey={selectedKey}
                options={options.map(option => ({
                    key: option.key,
                    text: option.text,
                }))}
                onChange={onChange}
                required={true}
            />
        </div>
    );
};

export default observer(RecurrenceChoiceComponent);
